import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=5aaf9a08&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=5aaf9a08&lang=scss&rel=stylesheet%2Fsass&scoped=true&"
import style1 from "./feedback.vue?vue&type=style&index=1&lang=scss&rel=stylesheet%2Fsass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf9a08",
  null
  
)

export default component.exports